/*
 * InfoEmail.jsx
 * Description:
 * Copyright (c) 2021 PredictiveUX
 */
import React from "react";

const InfoEmail = () => (
  <div className="create-account__line-container">
    <div className="create-account__subtitle light-black with-margin">
      You can send a receipt of this transfer to up to 5 people. If you wish to
      do so, please enter their email addresses below:
    </div>
  </div>
);

export default InfoEmail;
